import axios from 'axios';

import { config } from 'src/config';
import { authData$ } from 'src/store/auth.store';

export const request = axios.create({
	baseURL: config.baseUrl,
});

request.interceptors.request.use(config => {
	const authData = authData$.getState();

	if (!authData) { return config; }

	const headers = config.headers;
	headers['authorization'] = `Bearer ${authData.accessToken}`;

	return {
		...config,
		headers,
	};
});
